import { FC } from 'react';

import { LocalizationTypography } from '~components/organisms/localization';

const preAuthTextStyles = {
  fontSize: '12px',
  color: '#6B7280',
  fontFamily: 'Poppins',
  lineHeight: '16px',
  fontWeight: 400,
  textAlign: 'center',
};

export const PreAuthText: FC = () => {
  return (
    <LocalizationTypography
      textId="app.rentalPage.newStepThree.rentCharger.preAuthMayVaryNotice"
      defaultText="A temporary hold may be placed when your rental starts. The hold amount may vary by card type."
      sx={preAuthTextStyles}
    />
  );
};
